import logger from './logger';

const handleResponse = async (response, logId, startTime) => {
  const duration = Date.now() - startTime;
  const data = await response.json().catch(() => ({ error: 'Failed to parse JSON response' }));
  
  if (!response.ok) {
    const errorMessage = data.message || data.error || `HTTP error! status: ${response.status}`;
    logger.logError(logId, new Error(errorMessage), response.status);
    throw new Error(errorMessage);
  }

  logger.logResponse(logId, response.status, data, duration);
  return data;
};

const ncbClient = {
  request: async (method, path, body, params) => {
    const url = new URL(`/api/ncb${path}`);
    if (params) {
      Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
    }
    
    const logId = logger.logRequest('ncb', method, url.pathname + url.search, body);
    const startTime = Date.now();

    try {
      const response = await fetch(url.toString(), {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
      });
      return await handleResponse(response, logId, startTime);
    } catch (error) {
       const duration = Date.now() - startTime;
       logger.logError(logId, error, 'NETWORK_ERROR');
       throw error;
    }
  },

  createProject: (projectData) => ncbClient.request('POST', '/create-project', projectData),
  updateProject: (projectId, updateData) => ncbClient.request('POST', '/update-project', { id: projectId, data: updateData }),
  getProjects: () => ncbClient.request('POST', '/get-projects'),
  getProject: (projectId) => ncbClient.request('POST', '/get-project', { id: projectId }),
};

export default ncbClient;